export enum EchoTag {
	Tenant = "tenant",
	GenesisCareIntegration = "GenesisCareIntegration",
	SpireIntegration = "SpireIntegration"
}
